import http from "./http";

export const login = (credentials) => {
  return http.post("/users/auth/login", credentials);
};

export const reset = (credentials) => {
  return http.post("/users/auth/reset", credentials);
};

export const reg = (credentials) => {
  return http.post("/users/onboard/register", credentials);
};

export const verifyEmail = (credentials) => {
  return http.post("/users/onboard/verifyotp", credentials)
}

export const addmore = (credentials) => {
  return http.post("/users/onboard/addusername", credentials);
};

export const addpin = (credentials) => {
  return http.post("/users/onboard/createpin", credentials);
};

export const resetToken = (credentials) => {
  return http.post("/users/auth/sendpasstoken", credentials);
};

export const verifyToken = (credentials) => {
  return http.post("/users/auth/verifytoken", credentials);
};

export const verify2fa = (credentials) => {
  return http.post("/users/auth/verify2fa", credentials);
};

export const resetPassword = (credentials) => {
  return http.post("/users/auth/resetpassword", credentials);
};

//from forgot password page
export const updatePassword = (credentials) => {
  return http.post("/users/auth/resetpassword", credentials);
};

//from settings page
export const changePassword = (credentials) => {
  return http.patch("/users/settings/passwordchange", credentials);
};

export const logout = (credentials) => {
  return http.post("/users/auth/logout", credentials);
};

export const sendOtp = (credentials) => {
  return http.post("/users/onboard/resendotp", credentials)
}

export const performKyc = (payload) => {
  return http.post("/users/verify/bvnfull", payload)
}

export const updateTin = (payload) => {
  return http.post("/users/verify/matchtin", payload)
}

export const enable2FA = (payload) => { 
  return http.patch('/users/auth/enable2fa', payload); 
}

export const updateTransactionPin = (credentials) => {
  return http.patch("/users/settings/resetpin", credentials);
};